import { Link } from 'react-router-dom'
import { IMAGE_URL } from '../../Components/client-config';
import React from "react";
import Slider from "react-slick";
import useTrackEvent from '../../hooks/useTrackHook';
import { useHistory } from 'react-router-dom';
import RoundSkelton from '../../Assetes/SkeletonLoader/RoundSkelton';
import { useSelector } from 'react-redux';
import mergn from 'mergn-webapp-sdk'
import { useTranslation } from 'react-i18next';
import useCurrentLocale from '../../hooks/useLanguage';
import { getSlugFromName } from '../../utils/helpers';

function BrowseCategories(props: any) {
  const [addEvent] = useTrackEvent();
  let groupsData = useSelector((state: any) => state.menu.groupsData)
  let isLogged = useSelector((state: any) => state.customer.isLogged);
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [

      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },

    ],

  };
  settings.infinite = settings.slidesToShow === 4;
  const slideStyle = {
    margin: "0 30px",
  };
  const history = useHistory();
  const lang = useCurrentLocale();

  const handelPush = (elementId: any, groupName: string) => {
    history.push(`/${lang}/menu#${getSlugFromName(groupName)}`);
  }
  const handlePromotionClick = (item: any) => {
    let items = groupsData && groupsData.filter((g: any) => { return g.group_id === 7 })
    let finalItems = items[0] && items[0].data.map((item: any) => {
      return({
        id: item.menu_item_id,
        name: item.item_name
      })
    })
    let mapObj = {
      promotion_name: item.group_name,
      user_status: isLogged ? 'Logged In' : 'Logged Out',
      promotion_items: finalItems
    }
    let windowObj = (window as any)
    windowObj.dataLayer.push({ ecommerce: null });
    windowObj.dataLayer.push({
      'event': 'view_promotion',
      'ecommerce': mapObj
    })
  }

  const { t } = useTranslation();
  
  return (
    <div className='container '>
      <div>
        <div className='d-flex justify-content-between align-items-center'>
          <h2 className='items-title mb-3'><span>{t("EXPLOREMENU")}</span></h2>
          <div>
            <Link to={`/${lang}/menu`} className='b-view-all'>{t("VIEW_ALL")} </Link>
          </div>
        </div>
        <div className='browse-container'>
          {props.groups && props.groups.length > 0 ?
            <Slider {...settings}>
              {props.groups && props.groups.length > 0 ?
                props.groups.map((item: any, index: any) => {
                  return <div onClick={() => {
                    const slug = getSlugFromName(item.group_name);
                    sessionStorage.setItem("group_name", slug);
                    const isOnMenuPage = window.location.pathname.includes('/menu');

                    if (isOnMenuPage) {
                      // Update hash and trigger scroll via hashchange event
                      window.location.hash = slug;
                    } else {
                      // Navigate to menu page with hash
                      history.push(`/${lang}/menu#${slug}`);
                    }
                    addEvent({ category: "events", events: `${item.group_name}` })
                    mergn.recordEvent('Category Click', [
                      { eventProperty: 'category-name', value: item.group_name }
                    ]);
                    item.group_id == 7 && handlePromotionClick(item)
                  }} key={index} className='browser-design' style={slideStyle}>

                    <div className='brows-items'>
                      <Link to={`/${lang}/menu#${getSlugFromName(item.group_name)}`}>
                        {" "}
                        <img src={`${IMAGE_URL}${item.group_image}`} alt={item.group_name} />
                      </Link>
                      <h6 className='details-design'>{item.group_name}</h6>
                      <span></span>
                    </div>
                  </div>
                })
                : <div />
              }
            </Slider>
            :
            <RoundSkelton />
          }
        </div>
      </div>
    </div>
  )
}

export default BrowseCategories;